import React, { FC } from 'react';
import { TableRow, TableCell } from '@material-ui/core';
import NumberFormat from 'components/NumberFormat';
import Skeleton from '@material-ui/lab/Skeleton';

interface Props {
  item: SalesOrderItemModel;
  isLoading: boolean;
  index: number;
}

const BodyRow: FC<Props> = props => {
  const { item, index, isLoading } = props;

  return (
    <TableRow key={index + 1}>
      <TableCell>{isLoading ? <Skeleton variant='text' width='100%' /> : item.Product ? item.Product.productName : '-'}</TableCell>
      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <NumberFormat value={item.price} prefix={'Rp'} thousandSeparator={true} displayType='text' />
        )}
      </TableCell>
      <TableCell align='center'>{isLoading ? <Skeleton variant='text' width='100%' /> : item.totalItem}</TableCell>
      <TableCell align='center'>{isLoading ? <Skeleton variant='text' width='100%' /> : item.typeUnit}</TableCell>
      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <NumberFormat value={item.discount} prefix={'Rp'} thousandSeparator={true} displayType='text' />
        )}
      </TableCell>
      <TableCell align='right'>
        {isLoading ? (
          <Skeleton variant='text' width='100%' />
        ) : (
          <NumberFormat value={item.totalPrice} prefix={'Rp'} thousandSeparator={true} displayType='text' />
        )}
      </TableCell>
    </TableRow>
  );
};

export default BodyRow;
